import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgArrowRight = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: "1em",
	height: "1em",
	viewBox: "0 0 12 8",
	fill: "none",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M0.650391 3.65039H10.6504M10.6504 3.65039L6.90039 0.650391M10.6504 3.65039L6.90039 6.65039",
		stroke: "currentColor",
		strokeWidth: 1,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
export default SvgArrowRight;
